module.exports = __webpack_public_path__ + "img/icon-success.8e816d3b.png";